import { useState } from 'react';
import { Stack, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { sortTableData } from '../common/sortTableData';

import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import CheckIcon from '@mui/icons-material/Check';

const PopperMenu = (props) => {
  const { typography } = useTheme();
  const [selectedItem, setSelectedItem] = useState(props.initialItem);
  const styles = {
    menuItem: {
      padding: '12px 24px 12px 24px',
      width: '100%',
      ...typography.label14,
    },
  };

  // 吹き出しを閉じるときの処理
  const handleClose = () => {
    props.setOpen(false);
  };

  // 並び替えの方法が押された時に呼び出されるボタン
  const handleClick = (item) => {
    setSelectedItem(item);
    props.setTableData(sortTableData(props.tableData, item));
    handleClose();
  };

  return (
    <Popper
      open={props.open}
      anchorEl={props.anchorRef.current}
      sx={{ zIndex: 1300 }}
      transition>

      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: 'top' }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList sx={{ width: '224px' }}>
                <Stack sx={{ margin: '0px 0px 0px 24px' }}>
                  <p>並べ替え</p>
                </Stack>
                <Divider />
                <Stack sx={{ margin: '8px 0px 0px 0px' }}>
                  {
                    props.items.map((item) =>
                      <MenuItem key={item} onClick={() => {
                        handleClick(item);
                      }} sx={styles.menuItem}>
                        {item}
                        {item === selectedItem && <Stack sx={{ flexGrow: '1' }}>
                          <CheckIcon sx={{ color: 'primary.main', marginLeft: 'auto' }} />
                        </Stack>}
                      </MenuItem>,
                    )
                  }
                </Stack>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default PopperMenu;

PopperMenu.propTypes = {
  anchorRef: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  items: PropTypes.array,
  initialItem: PropTypes.string,
  tableData: PropTypes.array,
  setTableData: PropTypes.func,
};
